import * as types from './actionTypes';

export const fetchVacuumStatus = () => ({
    type: types.FETCH_VACUUM_STATUS,
});

export const fetchVacuumStatusSuccess = (data) => ({
    type: types.FETCH_VACUUM_STATUS_SUCCESS,
    payload: data,
});

export const fetchVacuumStatusFailure = (error) => ({
    type: types.FETCH_VACUUM_STATUS_FAILURE,
    payload: error,
});

export const fetchRdsEvents = (data) => ({
    type: types.FETCH_RDS_EVENTS,
    payload: data,
});

export const fetchRdsEventsSuccess = (data) => ({
    type: types.FETCH_RDS_EVENTS_SUCCESS,
    payload: data,
});

export const fetchRdsEventsFailure = (error) => ({
    type: types.FETCH_RDS_EVENTS_FAILURE,
    payload: error,
});
